"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerminalCreate = void 0;
var TerminalCreate_1 = require("./TerminalCreate");
Object.defineProperty(exports, "TerminalCreate", { enumerable: true, get: function () { return TerminalCreate_1.TerminalCreate; } });
